<md-content-box type="disabled">
	<div class="no-data-message">
		<md-icon md-border [icon]="iconUrl() || ''">{{ icon() }}</md-icon>
		<ng-content></ng-content>
	</div>
</md-content-box>
